module.exports = __webpack_public_path__ + "static/media/doubt-image.7d217286.svg";